"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pillSizes = exports.pillColours = void 0;
var pillColours = {
  YOLK: 'yolk',
  FOX: 'fox',
  DENIM: 'denim',
  OINK: 'oink',
  MIAMI: 'miami',
  KIDNEY_BEAN: 'kidneybean',
  CLAY: 'clay',
  JAM: 'jam',
  BLUEBERGINE: 'bluebergine',
  GHOST_DARK: 'ghost-dark',
  GHOST_LIGHT: 'ghost-light'
};
exports.pillColours = pillColours;
var pillSizes = {
  SMALL: 'small'
};
exports.pillSizes = pillSizes;